/**
 * Ticket Service
 * Requirement 56: Ticketing Adapters [MVP]
 */

import axios from 'axios';
import { getActiveTenantId } from './tenantContext';

export interface Ticket {
  id: string;
  source_type: 'recommendation' | 'anomaly' | 'tag_violation';
  source_id: string;
  provider: string;
  external_key: string | null;
  external_url: string | null;
  status: string;
  summary: string | null;
  created_at: string;
  updated_at: string;
}

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('accessToken');
  return {
    'x-tenant-id': getActiveTenantId(),
    'x-user-id': 'user-123',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

const costApiUrl = import.meta.env.VITE_COST_API_URL
  ? `${import.meta.env.VITE_COST_API_URL}/api/v1`
  : 'http://localhost:3002/api/v1';

export const ticketService = {
  async getTicket(sourceType: string, sourceId: string): Promise<Ticket | null> {
    const response = await axios.get(`${costApiUrl}/tickets`, {
      headers: authHeaders(),
      params: { source_type: sourceType, source_id: sourceId },
    });
    return response.data.ticket;
  },

  async createTicket(params: { source_type: 'recommendation' | 'anomaly' | 'tag_violation'; source_id: string; summary: string; description: string }): Promise<Ticket> {
    const response = await axios.post(`${costApiUrl}/tickets`, params, { headers: authHeaders() });
    return response.data.ticket;
  },
};
